module.exports = __webpack_public_path__ + "img/FelixTakacs.ca99dde.png";